module.exports = __webpack_public_path__ + "resources/icon_28_topic_circle.8f31949c6864f442.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-topic/img/icon_28_topic_circle.png
// module id = 792
// module chunks = 0 1